import {
  IntroductionFormValues,
  RemarkFormValues,
} from '@Utils/Types/FormValuesTypes';
import {
  CategoryMasterDataFormValues,
  StakeholderAnalysisFormValues,
  StakeholderGroupFormValues,
} from '../ImpactsOnStakeholdersFormProvider/types';
import { OtherIdStakeholderAnalysis } from './StakeholderAnalysValueChainFormCompletionCheckbox';
import {
  checkAssetsValidEn,
  checkAssetsValidTh,
} from '@Containers/UploadImageFormFields/utils';
import {
  checkEditorMessageEn,
  checkMessageEn,
  validateSpace,
  validateSpaceTextInput,
} from '@Utils/validation';
import { StakeholderType } from '@Domains/ImpactsOnStakeholder';

const getHasOtherStakeholders = (
  stakeholders: Array<CategoryMasterDataFormValues>
) => {
  return stakeholders.some(
    (stakeholder) =>
      stakeholder.infoCategoryMasterDataId ===
      OtherIdStakeholderAnalysis.OTHER_STAKEHOLDER
  );
};

export const checkStakeholderGroupCompletionTh = (
  stakeholderGroups: StakeholderGroupFormValues[]
) => {
  if (!stakeholderGroups || stakeholderGroups.length === 0) return false;

  return stakeholderGroups.every((group) => {
    const { stakeholders, otherStakeholders = [] } = group;
    const hasOtherStakeholders = getHasOtherStakeholders(stakeholders);

    if (stakeholders.length > 0) {
      if (hasOtherStakeholders) {
        const isZeroOtherLength = otherStakeholders?.length === 0;
        const everyOtherThComplete = otherStakeholders?.every(
          (other) => other.nameTh && other.nameTh.trim() !== ''
        );
        if (isZeroOtherLength || !everyOtherThComplete) return false;
        return true;
      }
      return true;
    }
    return false;
  });
};

export const checkStakeholderGroupCompletionEn = (
  stakeholderGroups: StakeholderGroupFormValues[]
) => {
  if (!stakeholderGroups || stakeholderGroups.length === 0) return false;

  return stakeholderGroups.every((group) => {
    const { stakeholders, otherStakeholders = [] } = group;
    const hasOtherStakeholders = getHasOtherStakeholders(stakeholders);

    if (stakeholders.length > 0) {
      if (hasOtherStakeholders) {
        const isZeroOtherLength = otherStakeholders?.length === 0;
        const everyOtherThComplete = otherStakeholders?.every(
          (other) => other.nameEn && other.nameEn.trim() !== ''
        );
        if (isZeroOtherLength || !everyOtherThComplete) return false;
        return true;
      }
      return true;
    }
    return false;
  });
};

export const checkAdditionalDescriptionEnRegex = (
  additionalDescriptionEn?: string
) => {
  if (!additionalDescriptionEn) return true;
  return (
    validateSpace(additionalDescriptionEn) &&
    checkEditorMessageEn(additionalDescriptionEn)
  );
};

export const checkAdditionalDescriptionThSpace = (
  additionalDescriptionTh?: string
) => {
  if (!additionalDescriptionTh) return true;
  return validateSpace(additionalDescriptionTh);
};

export const checkStkAnalysisRemarkTh = (remark?: RemarkFormValues): boolean =>
  !remark?.descriptionTh || validateSpaceTextInput(remark.descriptionTh);

export const checkStkAnalysisIntroductionValidTh = (
  introduction?: IntroductionFormValues
): boolean =>
  !introduction?.descriptionTh || validateSpace(introduction.descriptionTh);

export const checkStkAnalysisRemarkEn = (remark?: RemarkFormValues): boolean =>
  !remark?.descriptionEn ||
  (checkMessageEn(remark.descriptionEn) &&
    validateSpaceTextInput(remark.descriptionEn));

export const checkStkAnalysisIntroductionValidEn = (
  introduction?: IntroductionFormValues
): boolean =>
  !introduction?.descriptionEn ||
  (validateSpace(introduction.descriptionEn) &&
    checkEditorMessageEn(introduction.descriptionEn));

export const checkStkAnalysisAssetsValidTh = (
  stakeholderAnalysis?: StakeholderAnalysisFormValues
) => checkAssetsValidTh(stakeholderAnalysis);

export const checkStkAnalysisAssetsValidEn = (
  stakeholderAnalysis?: StakeholderAnalysisFormValues
) => checkAssetsValidEn(stakeholderAnalysis);

export const sortStakeholderGroups = (
  stakeholderGroups: StakeholderGroupFormValues[]
): StakeholderGroupFormValues[] => {
  const typeOrder = {
    [StakeholderType.INTERNAL]: 1,
    [StakeholderType.EXTERNAL]: 2,
  };

  return [...stakeholderGroups].sort((prev, next) => {
    return typeOrder[prev.stakeholderType] - typeOrder[next.stakeholderType];
  });
};
